import { css } from 'styled-components';

export const ProductSelectDropdownStyled = css`
    product-select-dropdown {
        .ant-select-item-option-content {
        display: flex;

        .text {
            flex: 2;
            min-width: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .sku {
            flex: 1;
            min-width: 0;
            margin-left: 8px;
            overflow: hidden;
            color: rgba(0, 0, 0, 40%);
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        }

        &.small .ant-select-item-option-content {
        min-width: 200px;
        max-width: 200px;
        }
    }
`;
